
{
  "familyId": "MET-SCHAAL-LENGTE",
  "questions": [
    {
      "id": "MET-SCHAAL-LENGTE-001",
      "familyId": "MET-SCHAAL-LENGTE",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_lengte",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond met schaal 1:200 is een kamer 4 cm lang. Hoe lang is de kamer in het echt?",
      "context": null,
      "options": ["8 meter", "80 meter", "800 cm", "4 meter"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 200,
            "mapLength": 4,
            "realLength": 8,
            "unit": "m",
            "label": "Schaal 1 : 200"
          }
        }
      ],
      "conceptId": "schaal_lengte_tekening_naar_echt",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.scale-unit-conversion", "label": "Eenheid verward: 800 cm = 8 m, niet 80 m — deelde door 10 i.p.v. 100", "optionIndex": 1 },
          { "id": "met.scale-unit-conversion", "label": "Vergeten om te rekenen naar meters: 800 cm = 8 m, niet 800 cm", "optionIndex": 2 },
          { "id": "met.scale-direction", "label": "Verkeerde schaalfactor: gebruikte ×100 i.p.v. ×200", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1:200 betekent: 1 cm op de tekening = 200 cm in het echt. De kamer is 4 cm op de tekening. Dus: 4 × 200 = 800 cm. Reken om naar meters: 800 ÷ 100 = 8 meter. Waarom werkt dit? De schaalfactor vertelt je hoeveel keer groter de werkelijkheid is dan de tekening.",
        "solutionSteps": [
          "Schaal 1:200 → 1 cm = 200 cm echt",
          "Tekenmaat: 4 cm",
          "4 × 200 = 800 cm",
          "800 cm ÷ 100 = 8 meter"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 cm × 200 = 800 cm = 8 meter.",
          "1": "Je dacht waarschijnlijk dat je 4 × 200 = 800 en dan nog eens door 10 moet delen. Maar 800 cm ÷ 100 = 8 meter, niet 80. Onthoud: 100 cm = 1 meter.",
          "2": "Je hebt 4 × 200 = 800 cm goed berekend, maar vergeten om te rekenen naar meters. 800 cm = 8 meter. Onthoud: deel door 100 om van cm naar m te gaan.",
          "3": "Je dacht waarschijnlijk dat schaal 1:200 betekent dat je met 100 vermenigvuldigt. Maar 1:200 betekent × 200. Dus 4 × 200 = 800 cm = 8 m. Onthoud: het tweede getal in de schaal is de vermenigvuldigingsfactor."
        }
      }
    },
    {
      "id": "MET-SCHAAL-LENGTE-002",
      "familyId": "MET-SCHAAL-LENGTE",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_lengte",
      "questionType": "multiple_choice",
      "question": "Een tuin is in het echt 15 meter lang. Op een tekening met schaal 1:500 is de tuin...",
      "context": null,
      "options": ["0,3 cm", "30 cm", "3 cm", "7,5 cm"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 500,
            "mapLength": 3,
            "realLength": 15,
            "unit": "m",
            "label": "Schaal 1 : 500"
          }
        }
      ],
      "conceptId": "schaal_lengte_echt_naar_tekening",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.scale-unit-conversion", "label": "Vergeten om m → cm om te rekenen: 15 m = 1500 cm, niet 15 ÷ 500", "optionIndex": 0 },
          { "id": "met.scale-unit-conversion", "label": "Eenheid verward: 15 m = 1500 cm, niet 150 cm", "optionIndex": 1 },
          { "id": "met.scale-direction", "label": "Verkeerde schaalfactor: deelde door 2 i.p.v. 500", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Eerst omrekenen: 15 meter = 1500 cm. Bij schaal 1:500 deel je door 500. Dus: 1500 ÷ 500 = 3 cm op de tekening. Waarom delen? Omdat de tekening kleiner is dan de werkelijkheid — je gaat van groot naar klein.",
        "solutionSteps": [
          "15 meter = 1500 cm",
          "Schaal 1:500 → deel door 500",
          "1500 ÷ 500 = 3 cm",
          "Antwoord: 3 cm op de tekening"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 15 ÷ 500 = 0,03 m = 0,3 cm moet rekenen. Maar je moet eerst naar cm omrekenen: 1500 ÷ 500 = 3 cm. Onthoud: werk altijd in dezelfde eenheid.",
          "1": "Je dacht waarschijnlijk dat 15 m = 150 cm. Maar 15 m = 1500 cm (× 100). 1500 ÷ 500 = 3 cm, niet 30 cm. Onthoud: 1 meter = 100 centimeter.",
          "2": "Goed! 15 m = 1500 cm, en 1500 ÷ 500 = 3 cm.",
          "3": "Je dacht waarschijnlijk dat je 15 ÷ 2 = 7,5 moet rekenen. Maar de schaal is 1:500, niet 1:2. Deel door 500, niet door 2. Onthoud: het tweede getal in de schaal is de deelfactor."
        }
      }
    },
    {
      "id": "MET-SCHAAL-LENGTE-003",
      "familyId": "MET-SCHAAL-LENGTE",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_lengte",
      "questionType": "multiple_choice",
      "question": "Op een kaart met schaal 1:50.000 is de afstand tussen twee dorpen 6 cm. Hoe ver is dat in het echt?",
      "context": null,
      "options": ["30 km", "3 km", "300 m", "0,3 km"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 50000,
            "mapLength": 6,
            "realLength": 3,
            "unit": "km",
            "label": "Schaal 1 : 50.000"
          }
        }
      ],
      "conceptId": "schaal_lengte_kaart",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.scale-unit-conversion", "label": "Eenheid verward: 300.000 cm = 3 km, niet 30 km — deelde door 10.000 i.p.v. 100.000", "optionIndex": 0 },
          { "id": "met.scale-unit-conversion", "label": "Nullen verkeerd geteld: 300.000 cm = 3.000 m = 3 km, niet 300 m", "optionIndex": 2 },
          { "id": "met.scale-direction", "label": "Verkeerd schaalgetal: gebruikte 5.000 i.p.v. 50.000", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "6 cm × 50.000 = 300.000 cm. Reken om: 300.000 cm ÷ 100 = 3.000 m ÷ 1.000 = 3 km. Bij kaartschalen werk je met grote getallen — schrijf alle nullen netjes op en reken stap voor stap om.",
        "solutionSteps": [
          "6 cm × 50.000 = 300.000 cm",
          "300.000 cm ÷ 100 = 3.000 m",
          "3.000 m ÷ 1.000 = 3 km",
          "Antwoord: 3 km"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 300.000 cm = 30 km. Maar 300.000 cm = 3.000 m = 3 km. Onthoud: deel door 100.000 om van cm naar km te gaan (100 × 1.000).",
          "1": "Goed! 6 × 50.000 = 300.000 cm = 3.000 m = 3 km.",
          "2": "Je hebt 300 m berekend, maar dat klopt niet. 6 × 50.000 = 300.000 cm = 3.000 m. Je bent waarschijnlijk gestopt bij 300 zonder de nullen mee te tellen. Onthoud: schrijf alle nullen op.",
          "3": "Je dacht waarschijnlijk dat je met 5.000 vermenigvuldigt in plaats van 50.000. Dan krijg je 6 × 5.000 = 30.000 cm = 300 m = 0,3 km. Maar de schaal is 1:50.000, niet 1:5.000. Onthoud: lees het schaalgetal zorgvuldig."
        }
      }
    },
    {
      "id": "MET-SCHAAL-LENGTE-004",
      "familyId": "MET-SCHAAL-LENGTE",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_lengte",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een huis op schaal 1:100. De voordeur is in het echt 2,10 meter hoog. Hoe hoog is de deur op de tekening?",
      "context": null,
      "options": ["21 mm", "21 cm", "0,21 cm", "2,1 cm"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 100,
            "mapLength": 2.1,
            "realLength": 2.1,
            "unit": "m",
            "label": "Schaal 1 : 100"
          }
        }
      ],
      "conceptId": "schaal_lengte_architect",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.scale-unit-conversion", "label": "Eenheid verward: 2,1 cm ≠ 21 mm als antwoordeenheid — juiste waarde, verkeerde eenheid", "optionIndex": 0 },
          { "id": "met.scale-direction", "label": "Verkeerde deelfactor: deelde door 10 i.p.v. 100 → 21 cm i.p.v. 2,1 cm", "optionIndex": 1 },
          { "id": "met.scale-direction", "label": "Verkeerde deelfactor: deelde door 1000 i.p.v. 100 → 0,21 cm", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "2,10 meter = 210 cm. Bij schaal 1:100 deel je door 100: 210 ÷ 100 = 2,1 cm op de tekening. Waarom eerst naar cm omrekenen? Omdat de schaal in centimeters werkt: 1 cm op tekening = 100 cm echt.",
        "solutionSteps": [
          "2,10 m = 210 cm",
          "Schaal 1:100 → deel door 100",
          "210 ÷ 100 = 2,1 cm",
          "Antwoord: 2,1 cm"
        ],
        "distractorExplanations": {
          "0": "2,1 cm en 21 mm zijn hetzelfde! Maar het antwoord wordt gevraagd in cm. 2,1 cm = 21 mm. Onthoud: 1 cm = 10 mm.",
          "1": "Je dacht waarschijnlijk dat je door 10 moet delen in plaats van 100. Maar schaal 1:100 = delen door 100. 210 ÷ 100 = 2,1 cm, niet 21 cm. Onthoud: het schaalgetal is de deelfactor.",
          "2": "Je dacht waarschijnlijk dat je door 1000 moet delen. Maar schaal 1:100 = delen door 100. 210 ÷ 100 = 2,1 cm, niet 0,21 cm. Onthoud: kijk goed naar het schaalgetal.",
          "3": "Goed! 210 cm ÷ 100 = 2,1 cm op de tekening."
        }
      }
    },
    {
      "id": "MET-SCHAAL-LENGTE-005",
      "familyId": "MET-SCHAAL-LENGTE",
      "module": "Metriek",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_lengte",
      "questionType": "fill_in",
      "question": "Op een plattegrond met schaal 1:250 is een gang 3 cm lang. Hoe lang is de gang in het echt? Typ je antwoord in meters (bijv. 7,5).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["7,5", "7.5"],
        "caseSensitive": false,
        "placeholder": "... meter"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 250,
            "mapLength": 3,
            "realLength": 7.5,
            "unit": "m",
            "label": "Schaal 1 : 250"
          }
        }
      ],
      "conceptId": "schaal_lengte_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Vermenigvuldig de tekenmaat met het schaalgetal: 3 cm × 250 = 750 cm. Reken om naar meters: 750 ÷ 100 = 7,5 meter. Onthoud: van tekening naar echt = vermenigvuldigen met de schaalfactor. Van echt naar tekening = delen door de schaalfactor.",
        "solutionSteps": [
          "3 cm × 250 = 750 cm",
          "750 cm ÷ 100 = 7,5 m",
          "Antwoord: 7,5 meter"
        ]
      }
    }
  ]
}
